/*
 *
 * OperationLoyaltyBonusList
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 15-Dec-2025
 */

import OperationLoyaltyBonusList from './OperationLoyaltyBonusList'

export default OperationLoyaltyBonusList
